import Base from 'app/views/base';

import tmpl from 'templates/empty';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'change select.predefined-selection': 'swapPredefinedPackagesContent',
    'change .mobile-nav select': 'navigateToHash',
  },

  initialize() {
    const self = this;
    $('body').on('activate.bs.scrollspy', (event) => {
      const hash = $(event.target).find('a').attr('href');
      self.displayCurrentSection(hash);
    });

    this.mobileNavHeight = $('.mobile-nav').outerHeight();
    const offset = 10;
    $('body').scrollspy({
      target: '.scrollnav',
      offset: $('.mobile-nav:visible').length ? this.mobileNavHeight + offset : offset,
    });
  },

  swapPredefinedPackagesContent(event) {
    this.$(event.target).find(':selected').tab('show');
  },

  displayCurrentSection(hash) {
    this.$('.mobile-nav select').val(hash);
  },

  navigateToHash(event) {
    const hash = this.$(event.target).find(':selected').val();
    if (window.history) {
      window.history.pushState(null, null, hash);

      // Fixed nav on mobile hides the Heading, so we scroll up after navigation
      $(window).scrollTop($(hash).offset().top - this.mobileNavHeight);
    } else {
      window.location.hash = hash; // old browsers
    }
  },
});



// WEBPACK FOOTER //
// ./app/views/api_docs_page.js